module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "inspection-tab-white"
  }, [_c('div', {
    ref: "slick_nav",
    staticClass: "slick_nav"
  }, _vm._l((_vm.inspection_diagnostics), function(inspection_diagnostic) {
    return _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": ("" + (inspection_diagnostic.photo)),
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    ref: "slick_for",
    staticClass: "slick_for"
  }, _vm._l((_vm.inspection_diagnostics), function(inspection_diagnostic) {
    return _c('a', {
      attrs: {
        "href": ("" + (inspection_diagnostic.photo)),
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": ("" + (inspection_diagnostic.photo)),
        "alt": ""
      }
    })])
  }))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-095d6446", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-095d6446"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionDiagnostic.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-095d6446"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionDiagnostic.vue
// module chunks = 0